import {noop} from 'lodash';
import {createContext, useContext, useEffect, useMemo, useState} from 'react';

export const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: noop,
});

export default function ThemeProvider({children}) {
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem('theme');
    return stored === 'dark' ? 'dark' : 'light';
  });

  useEffect(() => {
    document.body.className = ''; // Reset class
    document.body.classList.add(`bg-${theme}`, `text-${theme === 'dark' ? 'light' : 'dark'}`);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };
  
  const value = useMemo(() => ({
    theme,
    toggleTheme,
  }), [theme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
